import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.normalizeScroll(true);

const flipSlides = () => {
	const sectionWrapper = document.querySelector(".jbg-flip-slides");
	if (!sectionWrapper) return;

	const slides = gsap.utils.toArray(".jbg-flip-slide");

	slides.forEach((slide) => {
		// the slide's text content
		const contentWrapper = slide.querySelector(
			".wp-block-cover__inner-container"
		);

		// Pinning
		ScrollTrigger.create({
			trigger: slide,
			start: "top top",
			end: "bottom top",
			pin: true,
			pinSpacing: false,
		});

		// Unfold animation
		gsap.from(slide, {
			rotateX: -180,
			rotateY: 180,
			transformOrigin: "right bottom",
			ease: "power2.out",
			scrollTrigger: {
				trigger: slide,
				start: "top bottom",
				end: "center center",
				scrub: 1,
			},
		});

		// Reveal card content
		gsap.from(contentWrapper, {
			autoAlpha: 0,
			scrollTrigger: {
				trigger: slide,
				start: "center center",
				end: "bottom center",
				scrub: true,
			},
		});
	});
};

export default flipSlides;
